module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    attrs: {
      "epub:type": "chapter",
      "title": "Abbreviations"
    }
  }, [_c('h2', {
    staticClass: "h2b"
  }, [_c('a', {
    attrs: {
      "id": "page_xvi"
    }
  }), _c('a', {
    attrs: {
      "id": "frontmatter03"
    }
  }), _vm._v("ABBREVIATIONS")]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "20%"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("AA")])]), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "80%"
    }
  }, [_c('p', {
    staticClass: "para"
  }, [_vm._v("Antiaircraft")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("AAA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Antiaircraft Artillery")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("AAA AW")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Antiaircraft Artillery Automatic Weapons")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("A&P")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Ammunition and Pioneer")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("ARCT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Airborne Regimental Combat Team")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("AST")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Ammunition Supply Point")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("AT&M")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Antitank and Mine")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("BAR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Browning Automatic Rifle")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("BCT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Battalion Combat Team")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("CCF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Chinese Communist Forces")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("CG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Commanding General")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("CO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Commanding Officer")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("CP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Command Post or Check Point")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("DivArty")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Division Artillery")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("DUKW")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Amphibious Truck")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("EMT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Emergency Medical Tag")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("FA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Field Artillery")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("FAC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Forward Air Controller")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("FM")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Frequency Modulation")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("FO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Forward Observer")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("G-1/S-1")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Personnel Officer")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("G-2/S-2")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Intelligence Officer")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("G-3/S-3")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Operations Officer")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("G-4/S-4")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Supply Officer")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("HE")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("High Explosive")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "id": "page_xvii"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_vm._v("HEAT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("High Explosive Antitank")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("HMG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Heavy Machine Gun")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("HQ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Headquarters")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("I&R")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Intelligence and Reconnaissance")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("JCS")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Joint Chiefs of Staff")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("KATUSA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Korean Augmentation Troops for the United States Army")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("KIA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Killed in Action")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("KM AG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Korean Military Advisory Group")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("LD")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Line of Departure")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("LST")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Landing Ship Tank")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("MG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Machine Gun")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("MIA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Missing in Action")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("MLR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Main Line of Resistance")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("MSR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Main Supply Road")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("NCO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Noncommissioned Officer")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("NK")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("North Korea")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("OP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Observation Post; Outpost")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("OPL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Outpost Line")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("OPLR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Outpost Line of Resistance")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("P&A")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Pioneer and Ammunition")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("PLA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("People’s Liberation Army (Chinese Communist)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("POL")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Petroleum, Oil, and Lubrication")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("POW")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Prisoner of War")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("RCT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Regimental Combat Team")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Recon")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Reconnaissance")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("ROK")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Republic of Korea (South Korean)")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("R&R")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Rest and Recreation")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("SCR")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Signal Corps Radio")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("SOI")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Signal Operating Instructions")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("SOP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Standard Operating Procedure")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("SP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Self-propelled")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("TACP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Tactical Air Control Party")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("TF")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Task Force")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("T/O&E")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Table of Organization and Equipment")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("UN")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("United Nations")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("VT")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Variable Time Fuse")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('a', {
    attrs: {
      "id": "page_xviii"
    }
  }), _c('p', {
    staticClass: "para"
  }, [_vm._v("WIA")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Wounded in Action")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("WP")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("White Phosphorous")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para1"
  }, [_c('strong', [_vm._v("RANKS")])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para1"
  })])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Pvt.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para1"
  }, [_vm._v("Private")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("PFC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Private 1st Class")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Cpl.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Corporal")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Sgt.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Sergeant")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("S. Sgt.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Staff Sergeant")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("SFC")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Sergeant 1st Class")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("M. Sgt.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Master Sergeant")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("1st Sgt.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("First Sergeant")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("WOJG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Warrant Officer Junior Grade")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("CWO")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Chief Warrant Officer")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Lt.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Lieutenant")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("LtJG")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Lieutenant Junior Grade")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("2d Lt.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("2d Lieutenant")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("1st Lt.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("1st Lieutenant")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Capt.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Captain")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Maj.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Major")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Lt. Col.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Lieutenant Colonel")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Col.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Colonel")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Gen.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("General")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Brig. Gen.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Brigadier General")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Maj. Gen.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Major General")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Lt. Gen.")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "para"
  }, [_vm._v("Lieutenant General")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cdb3e4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter03.vue
// module id = 84
// module chunks = 0